import './LoadingSpinner.css';

const LoadingSpinner = () => {
    return (
        <div className="flex justify-center items-center mt-20">
            <div className="spinner text-purple-500"></div>
        </div>
    );
};

export default LoadingSpinner;
